import App from './App';
import { BuildKeyError } from './components/BuildKeyError';
import { getShopifyApiKey } from './utils/shopifyApiKey';

/**
 * Boot gate: renders the app only when a Shopify API key was injected into the
 * bundle. Otherwise shows a clear error instead of a silently broken embedded
 * app (App Bridge needs the key to obtain session tokens).
 */
export function RootGate() {
  const apiKey = getShopifyApiKey();
  return apiKey ? <App /> : <BuildKeyError />;
}
